import Dashboard from "@pathwright/web/src/modules/dashboard/Dashboard"
import { adminAccessRedirect } from "lib/core/routing/middleware"

export default {
  path: "/dashboard/",
  onEnter: adminAccessRedirect,
  component: Dashboard
}
